// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33rE8","content":"styles_content__1KRfx"};